/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classnames from 'classnames';
import { useContext, useState } from 'react';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { Transition } from 'palette/Transition';
import {
    useKeyboardClose, useScrollLock,
} from './hooks';
import ModalContext from './ModalContext';
import './styles/Modal.scss';

type ModalProps = React.PropsWithChildren<{
    id: string;
    className?: string;
    preventAutoFocus?: boolean;
    onClose?(): void;
    disablePortal?: boolean;
    disableOutsideClick?: boolean;
    closeOnOutsideHover?: boolean;
}>;

function Modal({
    id,
    children,
    className,
    preventAutoFocus = false,
    onClose,
    disablePortal = false,
    disableOutsideClick = false,
    closeOnOutsideHover = false,
}: ModalProps) {
    const [isTransitionExited, setIsTransitionExited] = useState(true);
    const { activeModalId, setActiveModalId, portalTargetId } = useContext(ModalContext);
    const isOpen = id === activeModalId;
    const showModal = isOpen || !isTransitionExited;
    const classes = classnames(className, 'palette-modal');
    useScrollLock(isOpen);
    useKeyboardClose(isOpen, preventAutoFocus, onClose);

    const closeOnOutsideMouseEvent = (event: React.MouseEvent) => {
        const modalElement = document.getElementById(id);

        if (event.target === modalElement) {
            event.preventDefault();
            setActiveModalId(null);
        }
    };

    const onOutsideClick = (event: React.MouseEvent) => {
        closeOnOutsideMouseEvent(event);
    };

    const handleOutsideHover = (event: React.MouseEvent) => {
        closeOnOutsideMouseEvent(event);
    };

    const modal = (
        <Transition
            appear
            classNames="palette-modal"
            property="background-color"
            show={isOpen}
            timeout="quick"
            onEnter={() => { setIsTransitionExited(false); }}
            onExited={() => {
                setIsTransitionExited(true);
                onClose?.();
            }}
        >
            <div
                className={classes}
                id={id}
                onClick={!disableOutsideClick ? onOutsideClick : undefined}
                onMouseOver={closeOnOutsideHover // eslint-disable-line jsx-a11y/mouse-events-have-key-events
                    ? handleOutsideHover
                    : undefined}
            >
                {children}
            </div>
        </Transition>
    );

    if (!showModal) {
        return null;
    }

    return disablePortal
        ? modal
        : createPortal(modal, document.getElementById(portalTargetId)!);
}

export type { ModalProps };
export default Modal;
